import { useState, useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { EditPage, EditPagePanel, EditPageTextField, EditPageSelect, EditPageCheckbox } from '../../../common/EditPage';
import { useParams, useNavigate } from 'react-router-dom';
import { getOne, create } from '../../../common/v4/BackendProvider';
import { toast } from 'react-toastify';
import SelectContainer from '../../../common/SelectContainer';
import DatePicker from 'react-datepicker';

const CarrierAccountBillingCreate = () => {
    const { carrier_id } = useParams();
    const navigate = useNavigate();
    const [data, setData] = useState({date: new Date()});
    const [metadata, setMetadata] = useState({});

    useEffect(() => {
        getOne(`/admin/carriers/carriers/${carrier_id}/billing/`, 'new').then(response => {
            setMetadata(response.data.metadata);
        }).catch(error => {
            toast.error("Error fetching billing: " + error.message, {});
        });
    }, []);
    const handleSave = () => {
        create(`/admin/carriers/carriers/${carrier_id}/billing`, {data: data}).then(() => {
            navigate(`/carriers/carriers/${carrier_id}/billing`);
        }).catch(error => {
            toast.error("Error creating payment: " + error.message, {});
        });
    };

    const handleCancel = () => {
        console.log('cancel');
        navigate(`/carriers/carriers/${carrier_id}/billing`);
    }

    const onChange = (id, value) => {
        setData({ ...data, [id]: value });
    }

    const onDateChange = (date) => {
        setData({ ...data, date: date });
    }

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick={true}
                pauseOnHover={true}
                draggable={true}
                progress="undefined"
            />
            <EditPage handleSave={ handleSave } handleCancel={ handleCancel } >
                <EditPagePanel>
                    <EditPageTextField label="Amount" id="amount" placeholder="0.00" onChange={ onChange } value={ data.amount } />
                    <SelectContainer label="Currency" id="currency" onChange={ onChange } value={ data.currency } options={ metadata?.currencies?.values } />
                    </EditPagePanel>
                    <EditPagePanel>
                    <EditPageTextField label="Description" id="description" onChange={ onChange } value={ data.description } />
                    <EditPageTextField label="Reference" id="reference" onChange={ onChange } value={ data.reference } />
                    
                    <div className="form-group">
                        <label>Date</label>
                        <div className="input-group col-lg-10">
                            <DatePicker
                                className="form-control datepicker"
                                selected={ data.date }
                                onChange={ onDateChange }
                                showTimeSelect
                                timeFormat="HH:mm"
                                dateFormat="yyyy-MM-dd HH:mm"
                            />
                        </div>
                    </div>
                </EditPagePanel>
            </EditPage>
        </>
    )
};

export default CarrierAccountBillingCreate;
